import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Routes } from '@/router';
import { AnalyticsEventCategory, AnalyticsEventAction, AnalyticsEventLabel } from '@/services/google/google-analytics.services';
import { CountryCode } from '@/store/ui';

@Component({
  name: 'CmgChipotleURewardsHistoryHeadBanner',
})
export default class CmgChipotleURewardsHistoryHeadBanner extends Vue {
  @Prop({ required: false, default: false, type: Boolean })
  pointsHistoryErrorState?: boolean;

  mounted() {
    this.$services.loyalty.refreshPoints();
  }

  get chipotleULogo(): string {
    return this.$appStore.state.cms.images.loyalty.chipotleULogo.default;
  }

  get backgroundImage(): string | undefined {
    return this.isMobile
      ? this.$appStore.state.cms.images.loyalty.rewardsHistoryHeadBannerBackground.mobile
      : this.$appStore.state.cms.images.loyalty.rewardsHistoryHeadBannerBackground.desktop;
  }

  get isMobile(): boolean {
    return this.$services.ui.isMobile();
  }

  get pointsBalance(): number {
    return this.$services.reward.getPointsBalance();
  }
  
  get isServiceOnline(): boolean {
    return !this.$appStore.state.reward.unreachable;
  }

  get isRewardsExchangeOnline(): boolean {
    return this.$appStore.state.featureFlags.orderingStatus?.isRewardsExchangeOnline ?? true;
  }

  get isRewardsOnline(): boolean {
    return this.$appStore.state.featureFlags.orderingStatus?.isRewardsOnline ?? true;
  }

  get countryCode(): string {
    return this.$appStore.state.ui.countryProfile.countryCode;
  }

  get pointsExpirationMessage(): string {
    switch (this.countryCode) {
      case CountryCode.CA:
        return 'Points expire after one year of inactivity.';
      default:
        return '';
    }
  }

  onClickScanReminder() {
    this.$services.googleAnalytics.sendCustomEvent({
      category: AnalyticsEventCategory.RewardsLanding,
      action: AnalyticsEventAction.ForgotToScanClick,
      label: AnalyticsEventLabel.RewardsForgotToScanClick,
    });
    this.$router.push({ name: Routes.RetroCredit });
  }

}
